
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,

  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class CursodMain extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    
  };

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    //this.cargar_materias_programadas();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    this.cargar_data();
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  //====================================================== 
  cargar_data = () => {
    let id_mate = this.props.store.materia.id_mate

    let param = { 
      id_mate: id_mate
    }
    
    axios2.post( 'cursod_main_get_obj', param)
    .then(res => {
        console.log(res.data);
        //if(res.data.length>0){ 
            this.setState({form: res.data});
        //}else{
            //NotificationManager.error('No existen datos');
        //}

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //====================================================== 
  //-----------------------------------------
 
  //------------------------------
  render() {
      //const materia = this.props.store.materia;
      const user = this.props.store.user
      const form = this.state.form
    return(
      <div>
        {/* ---   --- */}
       
        <div className="container">
        <br/>
        { 
          //JSON.stringify(this.state.form)
        }
          <div className="row">
            <div className="col-md-12">
              <div className="card p-3">
                <div className="box-header with-border">
                  {/*
                  <h5>Docente: {user.username}</h5>
                  */
                  }
                </div>

                {/*<!-- /.box-header -->*/}
                <div className="box-body">
                  <div className="row">
                    <div className="col-md-12">
                      {/*<!-----------Contenido------------->*/}
                      <div className="tiny_personalizado" style={{overflow: 'hidden'}}>


                        <div id="imagenHomeContainer" style={{textAlign: 'center'}}>
                          <img src={process.env.REACT_APP_AFILES + form.foto_path}
                               alt="" style={{width: '100%'}}/>
                        </div>

                        <h2 style={{textAlign: 'center' }}><span>¡Bienvenido!</span></h2>
                      </div>
                      {/*<!----------Fin Contenido---------------->*/}

                    </div> {/*<!-- col-md-12-->*/}
                  </div> {/*<!-- /.row -->*/}
                </div> {/*<!-- /.box-body -->*/}
              </div> {/*<!-- /.box -->*/}
            </div> {/*<!-- /.col -->*/}
          </div>

        </div>
        

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(CursodMain);